import { render } from "./CatalogCart.vue?vue&type=template&id=c239ae3a"
import script from "./CatalogCart.vue?vue&type=script&lang=js"
export * from "./CatalogCart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__